import { ModalProps } from "antd/lib/modal/Modal";
import { Modal, Spin } from "antd";
import React, {
    useContext,
    useImperativeHandle,
    useMemo,
    useState
} from "react";
import Style from "./index.module.scss";
import { CourseContext } from "../../../Store";
import StuSectionPicker from "./Components/StuSectionPicker";
import StuNavBar from "./Components/NavBar";
import useCurrentDate from "../../../../../utils/useCurrentDate";
import useRequest from "../../../../../utils/useRequest";
import { getSourceList } from "../../../../ResourcePool/service";
import PreviewSourceModal from "../../../../../components/PreviewSourceModal";
import useModalHandler from "../../../../../utils/v2/useModalHandler";
import CoursewareItem from "./Components/CoursewareItem";
import CustomEmpty from "../../../../../components/CourseComponents/CustomEmpty";
import { HaveWeekTime } from "../../../../../service/course";
import style from "../../../components/CourseLayout/components/CourseHeader/index.module.scss";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}
interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
}

const DataModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({});
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();
        const [weekTimeId, setWeekTimeId] = useState(course.weekTimeId);

        function weekTimeChange(weekTimeId: number) {
            setWeekTimeId(weekTimeId);
        }

        const [SourceList, { loading }, reload] = useRequest(
            () =>
                getSourceList({
                    batchNo,
                    courseNo: course.courseNo,
                    courseSeq: course.courseSeq,
                    delStatus: "",
                    keyword: "",
                    pageNo: 1,
                    pageSize: 9999,
                    weektimeId: weekTimeId
                }),
            {},
            [weekTimeId]
        );
        //预览
        const prevModal = useModalHandler(PreviewSourceModal);
        function onPrev(id: number | null) {
            if (id) {
                prevModal.setPayload(id);
                prevModal.open();
            }
        }
        const prevList = useMemo(() => {
            return SourceList?.data.filter(item => item.isPublish === 1) || [];
        }, [SourceList]);
        return (
            <Modal
                {...props}
                className={Style.root}
                centered
                onCancel={onCancel}
                onOk={onCancel}
                maskClosable={false}
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}>
                <Spin spinning={loading}>
                    <div className={Style.content}>
                        <div className={Style.padding}>
                            <h1 className={Style.title}>{course.courseName}</h1>
                            {course.weekTimeId !== HaveWeekTime.no && (
                                <StuSectionPicker
                                    weekTimeId={weekTimeId}
                                    onChange={weekTimeChange}
                                />
                            )}
                            {course.weekTimeId === HaveWeekTime.no && (
                                <span className={style.infos}>
                                    无学习计划或学习计划尚未同步到白果云
                                </span>
                            )}
                        </div>
                        <StuNavBar />
                        <div className={Style.padding}>
                            <div className={Style.count}>
                                课件（{prevList?.length || 0}）
                            </div>
                            <div className={Style.list}>
                                {prevList.map(item => (
                                    <div onClick={() => onPrev(item.id)}>
                                        <CoursewareItem
                                            key={item.id}
                                            data={item}
                                            indent={0}
                                        />
                                    </div>
                                ))}
                                {prevList?.length === 0 && (
                                    <CustomEmpty
                                        style={{ padding: "100px 0" }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </Spin>
                {prevModal.render(
                    <PreviewSourceModal type="student" data={prevList || []} />
                )}
            </Modal>
        );
    }
);

export default DataModal;
